import Button from '@mui/material/Button';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const ButtonLink = forwardRef((props, ref) => <Button component={Link} ref={ref} {...props} />);

export default ButtonLink;
